export default ($el: Element) => {
	if ($el instanceof HTMLElement) {
		const videoId = $el.dataset.videoId ?? '';
		const $iframeContainer = $el.querySelector('[data-select="iframeContainer"]');

		if (videoId && $iframeContainer) {
			const onClick = (e: MouseEvent) => {
				e.preventDefault();
				$iframeContainer.innerHTML = `
					<iframe
						src="//www.youtube.com/embed/${videoId}?wmode=transparent&autoplay=1"
						width="100%"
						height="100%"
						frameborder="0"
						allowfullscreen
					></iframe>
				`
			};

			$el.addEventListener('click', onClick, {once: true});
		}
	}
}
